export default __webpack_public_path__ + "static/media/firasans-regular.c19ef565.woff2";